<div class="h-screen w-screen background flex flex-col justify-center">
  <div class="p-10 card m-auto">
    <h1 class="text-white mb-3 text-center">Login</h1>
    <div>
      <form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-col gap-3 justify-between">
        <p>
          <mat-form-field>
            <input type="text" matInput placeholder="Email" formControlName="email">
          </mat-form-field>
        </p>

        <p>
          <mat-form-field>
            <input type="password" matInput placeholder="Password" formControlName="password">
          </mat-form-field>
        </p>

        <p *ngIf="error" class="error">
          {{ error }}
        </p>

        <div class="button flex flex-row w-full justify-end">
          <button type="submit" mat-button>Login</button>
        </div>

      </form>
    </div>
  </div>
</div>
